// Auth Pages Layout for Employee Portal

import { AuthBgImg1, AuthBgImg2 } from "@/assets";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="w-full min-h-screen relative overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#6C63FF] to-[#353093]" />

      {/* Top-left image */}
      <img
        src={AuthBgImg1}
        alt="Top Left"
        className="absolute top-0 left-0 h-auto max-w-[40%] object-contain"
      />

      {/* Bottom-right image */}
      <img
        src={AuthBgImg2}
        alt="Bottom Right"
        className="absolute bottom-0 right-0 h-auto max-w-[40%] object-contain"
      />

      {/* Main content */}
      <div className="relative min-h-screen flex w-full items-center justify-center">
        <div className="w-full lg:w-1/2 flex items-center justify-center p-0 sm:p-8">
          <div className="w-full sm:max-w-xl">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
